import { useDisplay } from 'vuetify'

export default {
  install(app) {
    app.mixin({
      computed: {
        $display() {
          // useDisplay() returns a reactive object
          return useDisplay()
        }
      }
    })
  }
}
